<template>
    <div>
        <Header title="队伍数据">
        </Header>
        
        <div class="my-white-mod" style="padding:10px 0;">
            <div style="margin:10px 30px 0">
                <span style="font-weight: bold; font-size: 18px;">数据概览</span>                     
                <DatePicker
                    :open="open_month"
                    :value="search_month"
                    confirm
                    type="date"
                    @on-change="handleChange"
                    @on-clear="handleClear"
                    @on-ok="handleOk"
                    style="margin-left:10px;cursor: pointer;"
                >
                    <span @click="handleClick"><Icon type="md-calendar" size="20"  />
                        <template v-if="search_month === getTodayDate()">今日</template>
                        <template v-else>{{ search_month }}</template>
                    </span>
                </DatePicker>
                
            </div>
            <div style="display: flex;padding:0 0 10px;">
                <div style="flex:6">
                    <div class="line-mod">
                        <div class="little-mod">
                            <div >今日成交金额</div>
                            <div class="little-mod-money">￥{{ staData.pay_order_money || 0 }}</div>
                            <div >较昨日{{ getText(staData.pay_order_money,staData.yes_pay_order_money)}} 
                                <span :class="(staData.pay_order_money-staData.yes_pay_order_money)>0?'top-money':'down-money'">
                                    {{ getNum(staData.pay_order_money,staData.yes_pay_order_money) }}
                                </span>
                            </div>
                        </div>
                        <div class="little-mod">
                            <div >今日成交订单数</div>
                            <div class="little-mod-money">{{ staData.pay_order_num || 0 }}</div>
                            <div>较昨日{{ getText(staData.pay_order_num,staData.yes_pay_order_num)}} 
                                <span :class="(staData.pay_order_num-staData.yes_pay_order_num)>0?'top-money':'down-money'">
                                    {{ getNum(staData.pay_order_num,staData.yes_pay_order_num) }}
                                </span>
                            </div>
                        </div>
                        <div class="little-mod">
                            <div >今日新增订单</div>
                            <div class="little-mod-money">{{ staData.today_order_num || 0 }}</div>
                            <div >较昨日{{ getText(staData.today_order_num,staData.yes_order_num)}} 
                                <span :class="(staData.today_order_num-staData.yes_order_num)>0?'top-money':'down-money'">
                                    {{ getNum(staData.today_order_num,staData.yes_order_num) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="line-mod">
                        <div class="little-mod">
                            <div >今日新增客户</div>
                            <div class="little-mod-money">{{ staData.today_customer_num || 0 }}</div>
                            <div >
                                较昨日{{ getText(staData.today_customer_num,staData.yes_customer_num)}} 
                                <span :class="(staData.today_customer_num-staData.yes_customer_num)>0?'top-money':'down-money'">
                                    {{ getNum(staData.today_customer_num,staData.yes_customer_num) }}
                                </span>
                            </div>
                        </div>
                        <div class="little-mod">
                            <div >最后成交人员</div>
                            <div class="little-mod-money">￥{{ staData.last_money || 0 }}</div>
                            <div style="padding-top:8px"><span class="name_text">{{ staData.last_name || '' }}</span></div>
                        </div>
                        <div class="little-mod">
                            <div >今日成单金额最高</div>
                            <div class="little-mod-money">￥{{ staData.best_money || 0 }}</div>
                            <div style="padding-top:8px"><span class="name_text">{{ staData.best_money_name || ''}}</span></div>
                        </div>
                    </div>
                </div>
                <div style="flex:4;padding:18px 0">
                    <div>
                        <div class="deal_heard_tittle">成交率</div>
                        <div>
                            <i-circle :percent="(staData.today_order_num ? ((staData.pay_order_num/staData.today_order_num)*100).toFixed(2) : 100)*1" :size="160">
                                <span class="demo-Circle-inner" style="font-size:20px;" >
                                    {{ staData.today_order_num ? ((staData.pay_order_num/staData.today_order_num)*100).toFixed(2) : 100}}%
                                </span>
                            </i-circle>
                        </div>
                    </div>                    
                </div>
            </div>            
        </div>
        
        <div class="my-white-mod">
            <div  class="new-mode" >
                <DatePicker  :open="open_day" :value="dateArr" @on-change="changeTime" confirm  format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                    <span @click="handleClick1" class="zhizhen"><Icon type="md-calendar" size="20"  />                             
                        <template v-if="(searchdata.start_day == '' && searchdata.end_day == '' )" >                        
                            <span style="padding-left:8px">
                                当月
                            </span>                        
                        </template>
                        <template v-else>{{ searchdata.start_day }}~ {{ searchdata.end_day }}</template>
                    </span>
                </DatePicker> 
                <Button @click="searchOneFun" type="warning" style="margin-left:10px">搜索</Button>
            </div>
            <div class="sales-style">
                <div>￥{{totalOneMoney}}</div>
                <div class="sales-text-style">销售总额</div>
            </div>
            <!-- 修改：加单量 -->
            <div class="sales-team">
                <div class="sales-team-item" v-for="(item, index) in totalData" :key="index">
                    <div class="sales-item-title">
                        <div>{{item.name}}</div>
                        <div>{{item.target_order_count}}</div>
                        <div>￥{{item.target_count_money}}</div>
                    </div>
                    <div class="sales-item-content" v-if=" item.member.length > 0">
                        <div class="sales-content-item" v-for="(t, i) in item.member" :key="i" >
                            <div>{{t.name}}</div>
                            <div>{{t.count}}</div>
                            <div>￥{{t.count_money}}</div>
                        </div>
                    </div>

                    <div class="sales-item-content" v-else style="padding:20px; text-align: center">
                        尚未分配队员
                    </div>
                </div>

            </div>
        </div>
        <div class="my-white-mod">
            <div  class="new-mode" >
                <DatePicker  format="yyyy-MM" type="month" placement="top-start" placeholder="选择月份" @on-change="changeDate" ></DatePicker>
                <Button @click="searchFun" type="warning" style="margin-left:10px">搜索</Button>
            </div>
<!--            <div style="margin-top:20px">-->
<!--                <Form :label-width="80" inline>-->
<!--                    <FormItem label="任务目标">-->
<!--                        <Select style="width:200px" filterable clearable v-model="searchTwo.id">-->
<!--                            <Option :value="item.id" v-for="(item, index) in target_list" :key="index">{{item.target_money}}</Option>-->
<!--                        </Select>-->
<!--                    </FormItem>-->
<!--                    <Button @click="get_team_target_amount" type="warning" style="margin-left:10px">搜索</Button>-->
<!--                </Form>-->
<!--            </div>-->
            <div style="display: flex;justify-content: space-around;font-size: 20px;margin:20px 0">
                <div>{{searchOne.month}}目标金额：{{info.money}}</div>
                <div>总销售额：{{totalMoney}}</div>
                <div>差额：{{info.money - totalMoney}}</div>
                <div>完成度：{{info.money ==0 ? 0 : (totalMoney / info.money * 100).toFixed(2)}}%</div>
                <div>剩余日目标：{{ info.number == 0 ? 0 : (info.money ==0 ? 0 : ((info.money - totalMoney )/ info.number).toFixed(2))}} </div>
            </div>
            <PageTable  :loading="table.loading" :columns="table.columns" :data="table.data" :current="table.current" :total="table.total" >
            </PageTable>
        </div>

    </div>

</template>
<script>
    import {target_amount, target_select, team_target_amount} from "@/api/system"
    import { daily } from "@/api/statistics"
    
    import {getNgumgberOfDays} from "@/utils/helper";
import {Header, PageTable,TableExpand} from "@/components/mainLayout"
export default {
    components:{
        Header,
        PageTable,
        TableExpand
    },
    data(){
        return{
            search_month:"",
            dateArr: [] ,
            open_month:false,
            open_day:false,
            searchdata:{
                start_day:'',
                end_day:''
            },
            totalData:{},
            totalMoney:0,
            totalOneMoney:0,
            target_list:{},
            searchOne:{
                month:"",
            },
            info:{
                money:0,
                start:0,
                end:0,
                current:0,
                number:0
            },
            staData: {
                    best_money: '',
                    best_money_name: '',
                    last_money: '',
                    last_name: '',
                    pay_order_money: '',
                    pay_order_num: '',
                    today_customer_num: 0,
                    today_order_num: 0,
                    yes_customer_num: 0,
                    yes_order_num: 0,
                    yes_pay_order_money: 0,
                    yes_pay_order_num: 0 
                },
            table:{
                loading:false,
                current:1,
                total:0,
                columns: [
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(TableExpand, {
                                props: {
                                    row: params.row
                                }
                            })
                        }
                    },
                    {
                        title: '组名',
                        align:'center',
                        key: 'name'
                    },
                    {
                        title: '目标金额',
                        align:'center',
                        key: 'target_money'
                    },
                    {
                        title: '实际金额',
                        align:'center',
                        key: 'actual_money'
                    },
                    {
                        title: '差额',
                        align:'center',
                        render: (h, params) => {
                            let money = (params.row.target_money - params.row.actual_money).toFixed(2);
                            return h('div', [
                                h('span', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                }, money)
                            ]);
                        }

                    },
                    {
                        title: '完成度',
                        align:'center',
                        render: (h, params) => {
                            let per = params.row.target_money ==0 ? 0 : (params.row.actual_money / params.row.target_money * 100).toFixed(2)
                            return h('div', [
                                h('span', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                }, per+"%")
                            ]);
                        }
                    }
                ],
                data: [],               
            },
            new_month:''

        }
    },
    mounted(){       
        this.get_target_amount();
        this.get_team_target_amount();
        this.search_month = this.getTodayDate()
        this.daily()
    },
    methods:{
        changeTime(e){
            if(e[0]){                
                this.searchdata.start_day = e[0]
                this.searchdata.end_day = e[1]
            }else{
                this.searchdata.start_day = ''
                this.searchdata.end_day = ''                
            }
            this.open_day = false
            // this.searchOneFun()
        },
        //获取当前日期函数
        getTodayDate() {
            let date = new Date(),
                year = date.getFullYear(), //获取完整的年份(4位)
                month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
                strDate = date.getDate() // 获取当前日(1-31)
            if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
            if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
            
            return `${year}-${month}-${strDate}`
        },
        getText(today,yes){
            if(today > yes){
                return '上升'
            }else if( today > yes ){
                return '不变'
            }else{
                return '下降'
            }
        },
        getNum(today,yes){
            if(yes == 0){
                // yes * 100 + '%'
                return  '100%'
            }else{
                let num = ((today-yes)/yes*100).toFixed(2)
                let baifen = Math.abs(((today-yes)/yes*100).toFixed(2))
                let a = ''
                if(num > 0){
                    a  = '↑'
                }else if(num==0){
                    a  = ''
                }else{
                    a  = '↓'
                }
                return  baifen + '%'  + a
            }

        },
        daily(){
            let data = {
                day: this.search_month || this.getTodayDate()
            }
            daily(data).then(res=>{
                this.staData = res.data;
            })
        },
        handleClick(){
            this.open_month = !this.open_month
        },
        handleClick1(){
            this.open_day = !this.open_day
        },
        handleChange(date){
            if(date){
                this.search_month = date;
            }else{
                this.search_month = this.getTodayDate()
                this.daily()
            }            
        },
        
        handleClear () {
                this.open_month = false;
        },
        handleOk() {
            console.log('this.search_month',this.search_month)
            this.open_month = false;
            this.daily()
        },
        searchOneFun(){
            this.get_target_amount();
        },        
        get_target_amount(){
            target_amount(this.searchdata).then(res=>{
                this.totalData = res.data;
                this.totalOneMoney = res.total_money
            })
        },
        changeDate(e){
            this.new_month = e
        },
        searchFun(){    
            this.searchOne.month =  this.new_month        
            this.get_team_target_amount();
        },
        target_select(){
            target_select().then(res=>{
                this.target_list = res.data;
            })
        },
        get_team_target_amount(){
            this.table.loading = true
            team_target_amount(this.searchOne).then(res=>{
                this.table.loading = false
                if(res.code == 200) {
                    this.totalMoney = res.data.total_money;
                    this.table.data = res.data.list;
                    this.info.money = res.data.money
                    this.info.start = res.data.firstDay
                    this.info.end = res.data.lastDay
                    this.info.current = res.data.current_month

                    this.info.number = getNgumgberOfDays(this.info.current, this.info.end)
                    console.log(this.info.number)
                } else {
                    this.$Message.error(res.msg)
                    this.table.data = [];
                    this.totalMoney =  0;
                    this.info.money = 0


                   
                }

            }).catch(err=>{
                this.table.loading = false
            })
        }
    }
}
</script>
<style>
.zhizhen {
    cursor: pointer;
}
    .little-mod{
        border:1px solid #ddd;
        border-radius:10px; 
        width:210px;
        padding:10px;
        margin:10px;
    }
    .little-mod-money{
        font-size:28px;
        font-weight: bold;
        padding-top:5px
    }
    .line-mod{
        display: flex;padding:8px 0;margin:0 20px;
    }
    .top-money{
        color:#ff0000;font-size:20px;font-weight: bold;
    }
    .name_text {       
        /* color: #3F8CFF; */
        font-size:16px;
        font-weight: bold;
    }
    .down-money{
        color:#19be6b;font-size:20px;font-weight: bold;
    }
    .sales-style{
        text-align: center;
        font-size:40px;
        color:#3F8CFF;
        padding:0 0 20px;
    }
    .sales-text-style{
        color:#0A1629;
        font-size: 18px
    }
    .deal_heard_tittle {
        padding-bottom: 16px;
        font-size: 16px;
    }
    .sales-team{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .sales-team-item{
        margin:0 10px 20px 0;
        width:20%;

    }
    .sales-team-item:nth-of-type(4n+4){
        margin-right: unset;
    }
    .sales-team-item:nth-of-type(1n+1){
        margin-left: 10px;
    }
    .sales-item-title{
        background: #3F8CFF;
        color:#ffffff;
        display: flex;
        justify-content: space-between;
        padding:15px 20px;
        font-size: 20px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .sales-item-content{
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.1);
        padding:0 10px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .sales-item-content div{
        padding-top:10px
    }
    .sales-item-content div:last-of-type{
        padding-bottom:10px
    }
    .sales-content-item{
        display: flex;
        justify-content: space-between
    }
    .new-mode{
        border-bottom:1px solid #ddd;
        margin-bottom:15px;
        padding-bottom:15px
    }
</style>
